var _style, _path, _path2, _g, _g2, _g3, _g4, _path3, _path4, _g5, _defs, _path5, _path6, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g8, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContractAgreement01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 599.2",
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;opacity:0.1;fill:#008080;enable-background:new    ;}\n\t.st1{fill:#F4F7FD;}\n\t.st2{fill:#102A54;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#FFC0B1;}\n\t.st5{fill:#096B68;}\n\t.st6{fill:#008080;}\n\t.st7{fill:#0C203F;}\n\t.st8{fill:#F99747;}\n\t.st9{fill:#EF8F48;}\n\t.st10{fill:#E6515C;}\n\t.st11{fill:#3D4D65;}\n\t.st12{clip-path:url(#SVGID_2_);fill:#0C203F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.7,504.2c44.8,4.6,89.9,6.4,134.1,7.1c104.3,1.8,208.8-6.7,311.5-25.4c70.6-12.8,131.7-41.8,143.9-118.7 c15.8-99.8-33-225.9-141.9-244.6c-33.7-5.8-68.7-5.5-101-16.6c-48.2-16.4-85.7-55.5-136.7-64.8c-52.1-9.4-110,1.7-151.8,36.6 c-18.4,15.3-34.1,33.3-48.8,52.1c-11.4,14.6-21.9,32.8-39.2,41c-21.2,10.1-45.9,2.1-69.2-1c-39.9-5.3-86.9,7.6-116.7,35.3 C64.7,234.3,55.4,288,59.6,328.3c5.5,52.8,31.6,102.4,76.8,131.6C187.4,492.9,252.8,498.2,311.7,504.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.7,526.9c0,0,830.9,0,831,0l0,0c2.6-0.1-16.7-60.5-18.6-65.7c-13.1-35.1-37.6-69.8-67.7-93.7 c-90.3-71.6-211.5-1.3-300.7,34.2c-28.5,11.3-58.7,20.5-89.7,21.5c-33,1-61.6-9.9-92.6-18.7c-52.9-15.1-111.3-17.5-162.3,2.8 C134.1,427.4,90.5,474.4,85.7,526.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M628.8,530.6H334.5c-23.1,0-41.8-18.7-41.8-41.8V116.4c0-23.1,18.7-41.8,41.8-41.8h294.3 c23.1,0,41.8,18.7,41.8,41.8v372.4C670.7,512,652,530.6,628.8,530.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M662.3,525.4H311.9c-7.8,0-14.2-6.4-14.2-14.2V82.8c0-7.8,6.4-14.2,14.2-14.2h350.3 c7.8,0,14.2,6.4,14.2,14.2v428.4C676.5,519,670.2,525.4,662.3,525.4z M311.9,69.4c-7.4,0-13.4,6.1-13.4,13.4v428.4 c0,7.4,6.1,13.4,13.4,13.4h350.3c7.4,0,13.4-6.1,13.4-13.4V82.8c0-7.4-6.1-13.4-13.4-13.4H311.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M412.3,99.3c1.7-1.7,3.7-2.5,6.2-2.5c3.4,0,5.8,1.1,7.3,3.3c0.8,1.3,1.3,2.5,1.4,3.8h-4.2 c-0.3-1-0.6-1.7-1-2.2c-0.7-0.9-1.8-1.3-3.3-1.3c-1.5,0-2.7,0.6-3.6,1.8c-0.8,1.2-1.3,3-1.3,5.2c0,2.2,0.5,3.9,1.4,5.1 c0.9,1.1,2.1,1.7,3.5,1.7c1.5,0,2.6-0.5,3.3-1.5c0.5-0.6,0.7-1.3,1-2.4h4.2c-0.4,2.2-1.3,3.9-2.8,5.3c-1.5,1.4-3.4,2.1-5.7,2.1 c-2.8,0-5.1-0.9-6.8-2.8s-2.5-4.4-2.5-7.7C409.6,103.9,410.5,101.2,412.3,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M446.2,115.6c-1.6,1.6-3.8,2.4-6.6,2.4s-5.1-0.8-6.6-2.4c-2-1.9-3-4.7-3-8.4c0-3.7,1-6.5,3-8.4 c1.6-1.6,3.8-2.4,6.6-2.4s5.1,0.8,6.6,2.4c2,1.8,3,4.6,3,8.4C449.2,110.9,448.2,113.7,446.2,115.6z M443.6,112.5 c1-1.2,1.5-3,1.5-5.2c0-2.3-0.5-4-1.5-5.2c-1-1.2-2.3-1.8-3.9-1.8s-3,0.6-4,1.8c-1,1.2-1.5,3-1.5,5.2c0,2.3,0.5,4,1.5,5.2 c1,1.2,2.3,1.8,4,1.8S442.6,113.8,443.6,112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.5,97.1h4.4l8,14.1V97.1h3.9v20.2h-4.2l-8.3-14.3v14.3h-3.9L452.5,97.1L452.5,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.5,97.1v3.6h-6.1v16.6h-4.2v-16.6h-6.1v-3.6H487.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M502.9,97.7c0.7,0.3,1.4,0.8,1.9,1.4c0.5,0.6,0.7,1.1,1,1.7c0.3,0.6,0.4,1.3,0.4,2.1c0,0.9-0.3,1.9-0.7,2.8 c-0.5,0.9-1.3,1.6-2.4,1.9c0.9,0.4,1.6,0.9,2,1.6c0.4,0.7,0.6,1.7,0.6,3.1v1.4c0,0.9,0,1.6,0.1,1.8c0.1,0.6,0.4,0.9,0.7,1.2v0.6 h-4.7c-0.1-0.5-0.2-0.8-0.3-1.1c-0.1-0.6-0.2-1.1-0.2-1.7v-1.8c0-1.3-0.3-2.1-0.6-2.6c-0.5-0.5-1.2-0.6-2.4-0.6h-4.1v7.9H490 V97.1h9.6C501.1,97.2,502.1,97.4,502.9,97.7z M494.2,100.7v5.4h4.5c0.9,0,1.6-0.1,2-0.4c0.8-0.4,1.2-1.1,1.2-2.3s-0.4-2-1.2-2.5 c-0.5-0.3-1.1-0.4-1.9-0.4L494.2,100.7L494.2,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M515.9,97.1h4.8l7.2,20.2h-4.6l-1.4-4.1h-7.4l-1.4,4.1h-4.4L515.9,97.1z M515.7,109.7h5.1l-2.6-8 L515.7,109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M532.4,99.3c1.7-1.7,3.7-2.5,6.2-2.5c3.4,0,5.8,1.1,7.3,3.3c0.8,1.3,1.3,2.5,1.4,3.8h-4.2 c-0.3-1-0.6-1.7-1-2.2c-0.7-0.9-1.8-1.3-3.3-1.3s-2.7,0.6-3.6,1.8c-0.8,1.2-1.3,3-1.3,5.2c0,2.2,0.5,3.9,1.4,5.1 s2.1,1.7,3.5,1.7c1.5,0,2.6-0.5,3.3-1.5c0.5-0.6,0.7-1.3,1-2.4h4.2c-0.4,2.2-1.3,3.9-2.8,5.3c-1.5,1.4-3.4,2.1-5.7,2.1 c-2.8,0-5.1-0.9-6.8-2.8s-2.5-4.4-2.5-7.7C529.5,103.9,530.4,101.2,532.4,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M565.4,97.1v3.6h-6.1v16.6h-4.2v-16.6H549v-3.6H565.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 175,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 203.5,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 232,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 260.6,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 289.1,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 317.7,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 346.3,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 374.7,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 403.3,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 431.9,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 460.4,
    className: "st3",
    width: 320.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 488.9,
    className: "st3",
    width: 320.8,
    height: 10.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M450.5,299l10.7,3.6l8.1-0.6l-1.6,3.7l13.7,8l-8.2,5.1c-2.9,1.8-6.7,1.7-9.5-0.5l-6.4-4.9l-12.1-3.1 L450.5,299z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M487.4,300.9l-9.7,3.6l-9.6-2.6l-0.3,4l-9.6,8.3l7.3,5.7c2.9,1.8,6.7,1.7,9.5-0.5l6.4-4.9l9.3-2.4 L487.4,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478,317.5c-0.1,0-0.1,0-0.2-0.1l-11.3-6.9c-0.2-0.1-0.2-0.3-0.1-0.5s0.3-0.2,0.5-0.1l11.3,6.9 c0.2,0.1,0.2,0.3,0.1,0.5C478.2,317.4,478.1,317.5,478,317.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M474.2,320.1c-0.1,0-0.1,0-0.2-0.1l-10.6-6.4c-0.2-0.1-0.2-0.3-0.1-0.5c0.1-0.2,0.3-0.2,0.5-0.1l10.6,6.4 c0.2,0.1,0.2,0.3,0.1,0.5C474.5,320,474.4,320.1,474.2,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M481.3,314.9c-0.1,0-0.1,0-0.2-0.1l-11.9-7.3c-0.5,0.1-2.2,0.5-3.9,0.8c-2.2,0.6-3.7-1.6-3.8-1.7l-0.2-0.3 l7.2-4.5c0.2-0.1,0.4-0.1,0.5,0.1s0.1,0.4-0.1,0.5l-6.5,4.1c0.5,0.5,1.5,1.4,2.8,1.1c2-0.5,4-0.8,4-0.8h0.1l0.1,0.1l12.1,7.3 c0.2,0.1,0.2,0.3,0.1,0.5C481.6,314.8,481.5,314.9,481.3,314.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M413.3,320.1l6.6,93.9c0.3,3.5,0.3,6.9,0.1,10.4l-4.6,80h-19.4l-20.9-119.7l-1.4-64.6L413.3,320.1 L413.3,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M413.3,320.1l-11.7,100.2c-0.4,2.8-0.8,5.7-1.4,8.5l-15.3,75.5h-22.4l2.8-77.9l-5.1-58.8 c0,0-14.7-21.1-6-47.6L413.3,320.1L413.3,320.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.5,511.7h13.7v3.6l14.1,5.3c1.9,0.7,3.1,2.5,3.1,4.5l0,0h-31c-1.6,0-2.7-1.4-2.3-2.9L364.5,511.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "365.7,504.3 365.4,511.7 376.4,511.7 377.6,504.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M399.4,511.7h13.7v3.6l14.1,5.3c1.9,0.7,3.1,2.5,3.1,4.5l0,0h-31c-1.6,0-2.7-1.4-2.3-2.9L399.4,511.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "399.8,504.3 400.5,511.7 411.5,511.7 412,504.3  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M455.5,329.2l-27.7-37.3c-1.1-4.5-2.3-9.1-3.4-13.6c-2.2-8.8-4.4-17.5-6.6-26.4c-1.7-7-2.8-15-5.5-21.6 c-2.2-5.2-7.3-8.7-13-8.9c-0.1,0-0.3,0-0.4,0h-36.1c-8.4,0-15,7.1-14.3,15.4l5.9,83.2h59v-9.6l29.5,28L455.5,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.3,314.2c-0.2,0-0.4-0.2-0.4-0.4l-0.2-11.5c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4l0.2,11.5 C413.7,314.1,413.5,314.2,413.3,314.2L413.3,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.3,276.8c-0.2,0-0.4-0.2-0.4-0.4l-1-29.1c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4l1,29.1 C410.6,276.6,410.5,276.7,410.3,276.8L410.3,276.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M383,231.3L383,231.3c-4.3,0.1-7.8-3.6-7.5-8l1.7-26l10.6-0.1l2.6,25.8C390.8,227.4,387.4,231.2,383,231.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M375,175.7l33.3-0.4l-0.3,2.1c-0.9,7.2-1.1,14.4-0.6,21.6c0.3,3.4,0.1,7.5-1.7,10.8 c-3.3,6.5-11.1,9.6-17.8,6.5C381.5,213.3,371,203.8,375,175.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M389.7,217.4L389.7,217.4c-0.3-0.1-5.1-1.6-8.3-5.3c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0 c3.1,3.7,7.8,5.1,7.9,5.1c0.2,0.1,0.3,0.3,0.2,0.5C390.1,217.3,389.9,217.4,389.7,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.6,176.9c0,0,0.6,11.8-2.2,13.6c-2.8,1.8-3.8-1.7-3.8-1.7s-4.1-11.9,2.3-14.7 C378.9,172.5,378.6,176.9,378.6,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M377.3,189.6c0,3-1.7,5.5-3.7,5.5c-2,0-3.8-2.4-3.8-5.4c0-3,1.7-5.5,3.7-5.5 C375.6,184.1,377.3,186.5,377.3,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.7,206.3L396.7,206.3c-0.2,0-3.5-0.2-6.4-4.6c-0.1-0.2-0.1-0.4,0.1-0.5c0.2-0.1,0.4-0.1,0.5,0.1 c2.7,4.1,5.8,4.3,5.8,4.3c0.2,0,0.4,0.2,0.4,0.4C397.1,206.2,396.9,206.3,396.7,206.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.8,169.1c-3.9-3.2-8.2-2-8.2-2s4.5-3.2,1.4-3.8c-3-0.6-25.2,1.5-25.2,1.5l0,0 c-14.2,0.6-22,15.3-10.8,15.2c6.4-0.2,11.7-2.4,15.1-4.3c2.6,2.6,9.4,7.6,22.1,5.2c16.9-3.1-0.4-7.3-0.4-7.3 S423.7,172.3,419.8,169.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M382.1,231.3h0.7c5.4,0,9.8-4.4,9.8-9.8l0,0h-20.3l0,0C372.3,226.8,376.7,231.3,382.1,231.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M374.1,234.6l15.2,29.8c1.6,3.1,4.1,5.5,7.3,7.1l54.9,26l-6.8,14.4l-57.3-14.5c-9.6-2.5-18.2-8.3-23.9-16.4 l-6.2-8.8c-7.7-11-7.6-25.7,0.3-36.6l1.6-2.1C363,228,371.1,228.7,374.1,234.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.6,312.1L444.6,312.1l-57.3-14.4c-9.7-2.5-18.3-8.4-24.1-16.6c-0.1-0.2-0.1-0.4,0.1-0.5 c0.2-0.1,0.4-0.1,0.5,0.1c5.7,8.1,14.1,13.9,23.7,16.4l57.2,14.4c0.2,0.1,0.3,0.3,0.3,0.5C444.8,312,444.7,312.1,444.6,312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.5,283.5c-0.1,0-0.1,0-0.2,0l-21.8-10.1c-5.8-2.6-10.5-7.2-13.2-12.8l-14.8-30.2c-0.1-0.2,0-0.4,0.2-0.5 c0.2-0.1,0.4,0,0.5,0.2l14.8,30.2c2.7,5.5,7.3,9.9,12.9,12.5l21.8,10.1c0.2,0.1,0.3,0.3,0.2,0.5 C421.8,283.5,421.7,283.5,421.5,283.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.4,330.7l2.4,3.1l2.8,1c1,0.4,1.7,1.4,1.6,2.4l-0.3,5.1c-0.1,1.4-1,2.5-2.3,2.8l-3.8,1 c-0.8,0.2-1.7,0.3-2.5,0.2l-1.7-0.2c-1.7-0.2-3-1.6-3.3-3.2l-0.6-3.6l-1.3-2.3L453.4,330.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.9,340l-20.2,4.6l-0.6-2.3c-0.6-2.4-2.9-3.9-5.2-3.3l-11.4,2.6c-2.4,0.6-3.9,2.9-3.3,5.2l0.6,2.3 l-20.2,4.6c-2.3,0.6-3.8,2.8-3.2,5.1l9.6,41.9c0.6,2.3,2.8,3.8,5.1,3.2l60.3-13.8c2.3-0.6,3.8-2.8,3.2-5.1l-9.6-41.9 C492.5,340.9,490.2,339.5,487.9,340z M448.2,346.6c-0.4-1.7,0.7-3.6,2.5-3.9l11.4-2.6c1.7-0.4,3.6,0.7,3.9,2.5l0.6,2.3l-17.8,4 L448.2,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M463,370.3l-37.9-13c-0.5-0.2-0.6-0.6-0.6-1c0.2-0.5,0.6-0.6,1-0.6l36.9,12.7l27.7-27.4 c0.4-0.3,0.8-0.3,1.2,0c0.3,0.4,0.3,0.8,0,1.2L463,370.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M465.8,370.2l-5.3,1.2c-0.8,0.2-1.6-0.3-1.7-1.1l-0.6-2.3c-0.2-0.8,0.3-1.6,1.1-1.7l5.3-1.2 c0.8-0.2,1.6,0.3,1.7,1.1l0.6,2.3C467.1,369.3,466.5,370.1,465.8,370.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M454.1,338l2.3-0.6c0,0,0.2,3.6,1.1,4.9c0.8,1.4,2.3,0.9,2.3,0.9l0.5-6l-2.8-1.9L454.1,338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M459.3,343.7c-0.6,0-1.5-0.3-2-1.1c-0.7-1.2-1-3.3-1.1-3.9l-2-0.3c-0.2,0-0.3-0.2-0.3-0.3 c0-0.2,0.2-0.3,0.3-0.3l2.5,0.4v0.2c0,0,0.2,2.7,1,3.9c0.7,1.2,1.9,0.8,1.9,0.8c0.2,0,0.3,0,0.4,0.2c0,0.2,0,0.3-0.2,0.4 C459.6,343.6,459.4,343.7,459.3,343.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M456.3,343.1c0,0-1.6-3.2-2.6-3.8c-1-0.6-6.2,1.7-6.5,3.3c-0.3,1.6-0.3,2.2-0.3,2.2s-0.1,1.7,4.4,1.7 C455.9,346.5,456.3,343.1,456.3,343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M446.8,344.8c-0.1,0-0.3-0.1-0.3-0.2c0,0-0.6-3.5,2.7-4.8c3.9-1.5,5.4-0.2,6,0.8c0.1,0.1,0,0.3-0.1,0.4 s-0.3,0-0.4-0.1c-0.8-1.4-2.8-1.6-5.3-0.6c-2.8,1.1-2.4,4-2.4,4.1C447,344.6,446.9,344.7,446.8,344.8L446.8,344.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M382,231.6c-2.6,0-4.8-0.7-6.4-2.3c-3.3-2.9-3.6-7.7-3.6-7.9c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.1,0.3,4.7,3.4,7.4c1.7,1.6,4,2.2,6.8,2.1c0.2,0,0.4,0.1,0.4,0.4c0,0.2-0.1,0.4-0.4,0.4C382.6,231.6,382.3,231.6,382,231.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M553.7,319.8l-19.9,91.9c-0.7,3.4-1.3,6.8-1.6,10.3l-6.9,79.8l19.2,2.8l37.8-115.5l10.6-63.7L553.7,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M556.1,320.5l23.2,105.9c0.7,2.8,1.6,5.5,2.6,8.2l25.9,72.6L630,504l-13.8-76.7l-3.3-58.9 c0,0,11.6-23-0.8-47.9L556.1,320.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M629.2,512.8h-13.7v3.6l-14.1,5.3c-1.9,0.7-3.1,2.5-3.1,4.5l0,0h31c1.6,0,2.7-1.4,2.3-2.9L629.2,512.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "627.3,504.3 628.3,512.8 616.5,512.8 615,506.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M538.9,512.8h-13.7l-1,3.9l-13,4.9c-1.9,0.7-3.1,2.5-3.1,4.5l0,0h31c1.6,0,2.7-1.4,2.3-2.9L538.9,512.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "540.4,504 538.4,512.8 526.3,512.8 527.2,502.1  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M553.5,320.5l0.7-84.3c0.1-7.7,6.3-13.9,14.1-13.9h32.9c7.9,0,14.2,6.5,14.1,14.4l-2.6,83.8H553.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M555.1,231.5l-14.6,40.1c-1.6,4.3-4.9,7.8-9.2,9.6l-44.2,18.7l3.9,12.6l40.8-5.1 c8.7-1.1,16.9-5.1,23.3-11.1l0,0L555.1,231.5L555.1,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M613.4,229.4l26.7,44c2.1,3.4,3.5,7.3,4.1,11.2l0,0c1.1,6.7-0.1,13.5-3.3,19.5l-19.8,37.1l-13.5-5.4 l14.6-46.2l-18.9-25.8L613.4,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M554.1,297.9L554.1,297.9c-0.2,0-0.4-0.2-0.4-0.4l0.2-52.5c0-0.2,0.2-0.4,0.4-0.4l0,0 c0.2,0,0.4,0.2,0.4,0.4l-0.2,52.5C554.3,297.9,554.2,297.9,554.1,297.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M613.7,278.1c-0.1,0-0.2-0.1-0.3-0.2L603,263.9c-0.1-0.2-0.1-0.4,0.1-0.5c0.2-0.1,0.4-0.1,0.5,0.1 l10.4,14.1c0.1,0.2,0.1,0.4-0.1,0.5C613.8,278.1,613.8,278.1,613.7,278.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M577.1,163.7c-3.2-0.3-6.5,0.1-9.4,1.1c-7.9,2.8-9.5,11-8.6,18.1c0.6,5.4,0.6,10.9,0.2,16.4 c-0.3,3.4-0.1,7.5,1.7,10.8c3.3,6.5,11.1,9.6,17.8,6.5c6.6-2.9,10.7-9.2,12.4-16c1.5-5.4,0.9-11,1.3-16.5 c0.4-5.2,0.8-10.2-2.8-14.5C586.7,166,581.9,164.1,577.1,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M583.8,231.5L583.8,231.5c4.3,0.1,7.8-3.6,7.5-8l-1.7-26l-10.6-0.1l-2.6,25.8 C576.1,227.8,579.5,231.5,583.8,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M577.1,217.7c-0.2,0-0.3-0.1-0.4-0.3s0-0.4,0.2-0.5c0.1,0,4.8-1.6,7.9-5.1c0.1-0.2,0.4-0.2,0.5,0 c0.2,0.1,0.2,0.4,0,0.5C582,216,577.3,217.6,577.1,217.7C577.2,217.7,577.1,217.7,577.1,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M588.2,177.2c0,0-0.6,11.8,2.2,13.6c2.8,1.8,3.8-1.7,3.8-1.7s4.1-11.9-2.3-14.7 C587.9,172.8,588.2,177.2,588.2,177.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.072740e-02 -0.9999 0.9999 1.072740e-02 396.9352 781.1316)",
    className: "st4",
    cx: 593.2,
    cy: 190,
    rx: 5.4,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560,172.5c0,0-3.5,1.3-3.8,5.1c-0.3,3.1,0.4,9.3,3.3,11.2C559.6,188.7,559.3,182.4,560,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M570.7,206.4c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.1-0.4,0.3-0.4c0.1,0,4.8-0.5,6.4-4.8 c0.1-0.2,0.3-0.3,0.5-0.2c0.2,0.1,0.3,0.3,0.2,0.5C575.9,205.8,570.8,206.4,570.7,206.4L570.7,206.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M576.7,222.3l6.4,9.1l-2.5,1.3c-3.8,1.9-8.3-0.5-8.8-4.7l-0.7-5.7L576.7,222.3L576.7,222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M583.1,231.3l2.8,1.6c3.6,2,8.1-0.1,8.8-4.1l1.2-6.4h-4.7L583.1,231.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "583.1,231.3 585.4,232.5 585.2,296.2 578.5,306.9 574,294.9 580.9,232.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "609.7,336.6 608,340 604.2,341.2 611.8,356.1 619.3,340.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "553.5,320.5 612.6,320.5 612.6,317.1 553.6,317.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M568.8,321.4h-2.5c-1.3,0-2.4-1.1-2.4-2.4v-0.3c0-1.3,1.1-2.4,2.4-2.4h2.5c1.3,0,2.4,1.1,2.4,2.4v0.3 C571.1,320.3,570.1,321.4,568.8,321.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120,192.6l-25.1-30.7c-2-2.4-1.9-6,0.3-8.3l0,0c2.4-2.6,6.3-2.8,8.9-0.4l33.5,31L173,215l-19.2,16 L120,192.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.8,133.6L93.4,180.8c-6.6,1.3-13-3-14.4-9.6l0,0c-1.3-6.6,3-13,9.6-14.4l238.5-47.2L331.8,133.6z"
  })), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st11",
    points: "327,109.5 365.4,114.4 331.8,133.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "327,109.5 365.4,114.4 331.8,133.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M367.9,114c0.6,2.7-2,5.4-5.7,6.2c-3.7,0.7-7.1-0.8-7.5-3.5c-0.6-2.7,2-5.4,5.7-6.2 S367.3,111.4,367.9,114z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.9,156.9l-0.6-3.5c-0.3-1.6,0.1-3.3,1-4.6c0.9-1.3,2.5-2.2,4-2.4l45.4-5.1c2.1-0.3,4.1-0.9,5.9-1.9 l9.1-5.3l0.7,1.3l-9.1,5.3c-2,1.2-4.2,1.9-6.5,2.2l-45.4,5.1c-1.2,0.2-2.3,0.7-3,1.7c-0.7,1-1,2.2-0.7,3.4l0.6,3.5L87.9,156.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M221.4,512.8h13.7v3.6l14.1,5.3c1.9,0.7,3.1,2.5,3.1,4.5l0,0h-31c-1.6,0-2.7-1.4-2.3-2.9L221.4,512.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "221.8,505.5 222.4,512.8 233.5,512.8 234,505.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.2,512.8h13.7v3.6l14.1,5.3c1.9,0.7,3.1,2.5,3.1,4.5l0,0h-31c-1.6,0-2.7-1.4-2.3-2.9L154.2,512.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "157.1,505.5 155.3,512.8 166.4,512.8 168.2,505.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M235.3,321.2h-59c0,0-14.6,19.8-3.5,50.9l-4,58.9c-0.1,1.8-0.4,3.7-0.7,5.4l-13.2,69H173l25.9-69.4 c0.6-1.5,1-3,1.3-4.6l6-34.1l4.1,16.8l7.6,91.4h19.4l5.2-92.1L235.3,321.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.9,354v-32.7c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v31.3l1.3-0.9c2-1.5,3.2-3.8,3.2-6.2v-24.3 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v24.3c0,2.7-1.3,5.2-3.5,6.8L208.9,354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.1,397.7L206.1,397.7c-0.2,0-0.4-0.2-0.4-0.4l3.1-44.1c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 l-3.1,44.1C206.5,397.5,206.3,397.7,206.1,397.7z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205,232.6L205,232.6c-4.3,0.1-7.8-3.6-7.5-8l1.7-26l10.6-0.1l2.6,25.8C212.7,228.8,209.4,232.5,205,232.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197,177.1l33.3-0.4l-0.3,2.1c-0.9,7.2-1.1,14.4-0.6,21.6c0.3,3.4,0.1,7.5-1.7,10.8 c-3.3,6.5-11.1,9.6-17.8,6.5C203.4,214.8,192.9,205.2,197,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.7,218.8L211.7,218.8c-0.3-0.1-5.1-1.6-8.3-5.3c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0 c3.1,3.7,7.8,5.1,7.9,5.1c0.2,0.1,0.3,0.3,0.2,0.5C212,218.7,211.9,218.8,211.7,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.3,190.9l6.8-12.2l23.7,3c0,0,8.8-5.3,0.6-13.1c-8.3-7.7-34.5-1-36.1,5.7c-1.6,6.7-0.9,14.8-0.9,14.8 L199.3,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.3,190.9c0,3-1.7,5.5-3.7,5.5s-3.8-2.4-3.8-5.4c0-3,1.7-5.5,3.7-5.5 C197.6,185.5,199.2,187.9,199.3,190.9z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.4,183.8l-36.5-34.3l-12.1,2.6l-2.3-2.8c-1-1.4-2.8-1.8-4.4-1.1l2.8,6.7c0.5,1,1.1,1.8,2,2.4l8.3,5 l24.4,29.9l-18.6,14l15.1,18.4l21.5-21.7c2.5-2.5,3.9-5.9,3.9-9.4C290.6,189.6,289.1,186.2,286.4,183.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267.2,224.7L251,203.8l-27,19.5c-0.7-0.1-1.4-0.2-2.1-0.2l-31.2-0.4c-0.3,0-0.6,0-0.8,0l0,0l-27.3-19.7 l-17.5,19.7l28.4,31.3l0,0l2.8,67.1h59l3.2-67.2L267.2,224.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.2,152.4l-8.8-1.4c-1.9-0.4-4.4,0.9-6.1,1.9c-1.1,0.7-2,1.6-2.9,2.6l-2.3,2.8c-0.6,0.6-0.2,1.6,0.6,1.7 l2.7,0.6c2.2,0.5,4.5-0.1,6.2-1.6l4.5-4l2.8,0.3c2.4-0.1,2.3-0.4,3.7-2.4l0,0C109.6,152.7,109.5,152.4,109.2,152.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.3,154.1c-0.1,0-0.1,0-0.2-0.1c-2.3-1.4-9.2-1.6-9.2-1.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 c0.3,0,7.1,0.3,9.6,1.7c0.2,0.1,0.2,0.3,0.1,0.5S247.4,154.1,247.3,154.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103,155.4L103,155.4l-3.2-0.4c-0.2,0-0.4-0.2-0.3-0.4c0-0.2,0.2-0.4,0.4-0.3l3.1,0.3c0.2,0,0.4,0.2,0.3,0.4 C103.3,155.3,103.2,155.4,103,155.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.2,195.7C135.2,195.7,135.1,195.7,135.2,195.7c-0.3-0.1-0.4-0.3-0.4-0.5c0.9-4.5,6.3-7.6,6.6-7.7 c0.2-0.1,0.4,0,0.5,0.1c0.1,0.2,0,0.4-0.1,0.5c-0.1,0-5.3,3-6.2,7.3C135.5,195.5,135.4,195.7,135.2,195.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.8,194.7c-4.9,0-8.9-2.3-9.2-2.5c-0.2-0.1-0.2-0.3-0.1-0.5c0.1-0.2,0.3-0.2,0.5-0.1 c0.1,0,5.7,3.2,11.4,2.1c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4C279.5,194.6,278.6,194.7,277.8,194.7z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "788.2,218.8 803.3,218.8 806.2,317.3 747.1,317.3 753.6,218.8 767.9,218.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "742,418.7 742,441.8 748.7,513.1 759.7,513.1 764.3,443.4 766,418.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M759.7,513.1h-11l-1.1,3.6l-14.1,5.3c-1.9,0.7-3.1,2.5-3.1,4.5l0,0h31c1.6,0,2.7-1.4,2.3-2.9L759.7,513.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "769.4,418.7 769.4,441.9 776.2,513.1 787.2,513.1 791.6,441.9 794.4,418.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M787.2,513.1h-11l-1.7,3.6l-14.1,5.3c-1.9,0.7-3.1,2.5-3.1,4.5l0,0h31c1.6,0,2.7-1.4,2.3-2.9L787.2,513.1z "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M747.1,317.3l-13.3,101.4h67.8l-0.4-15.1c-0.5-18.4,1.7-36.7,6.7-54.3c2.4-8.3,3.2-19.3-1.7-32.1H747.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M843.4,181.7l-3-61.8h-13.8l-3.8,59.7c-0.1,2.1-0.8,4-2,5.8l-25.4,33.3l3.5,114.7l31.5-10.9l-11.1-58.1 c-3-16-0.2-32.6,8.1-46.7l12.3-20.9C842.3,192.4,843.6,187.1,843.4,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M714.4,181.7l3-61.8h13.8l3.8,59.7c0.1,2.1,0.8,4,2,5.8l25.4,33.3L759,333.5l-31.5-10.9l12.6-66 c2.1-10.8,0.1-22.1-5.5-31.7L718.2,197C715.4,192.4,714.1,187.1,714.4,181.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M779,228.5h-1.8c-5.1,0-9.3-4.1-9.3-9.3v-0.6h20.3v0.6C788.2,224.4,784.1,228.5,779,228.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "753.6,179.7 750.5,206.7 760.6,206.7 762.8,178.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M778,226.7L778,226.7c3.9,0,6.9-3.2,6.7-7.1l-1.6-23.1l-9.4-0.1l-2.3,23 C771.1,223.3,774.1,226.7,778,226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M785.1,177.4l-29.6-0.3l0.2,1.8c0.8,6.3,1,12.8,0.5,19.1c-0.3,3-0.1,6.7,1.5,9.6 c2.9,5.8,9.8,8.5,15.8,5.8C779.5,210.9,788.7,202.4,785.1,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M772,214.4c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.2,0-0.4,0.2-0.4c0,0,4.2-1.4,7-4.6c0.1-0.1,0.3-0.2,0.5,0 c0.1,0.1,0.2,0.3,0,0.5C776.4,213.1,772.3,214.4,772,214.4C772.1,214.4,772.1,214.4,772,214.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.073519e-02 -0.9999 0.9999 1.073519e-02 588.0615 974.077)",
    className: "st4",
    cx: 786.3,
    cy: 189.8,
    rx: 4.9,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M765.9,204.6c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.4l0,0c0,0,2.8-0.2,5.1-3.8 c0.1-0.2,0.3-0.2,0.5-0.1s0.2,0.3,0.1,0.5C768.9,204.4,766,204.6,765.9,204.6L765.9,204.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M768.5,177.2c0,0,9.4,8.2,17.3,9l-3.8,20.6h10.7c0,0,6.1-24.2-5.3-36.7 C776.2,157.4,764.7,171.6,768.5,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M768.5,177.2c0,0-3.9,4.8-12.5,5c-8.6,0.2-6.6-14.3,2.6-16.5c9.2-2.2,17.6,0.6,17.6,0.6L768.5,177.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M828.5,119.9v-6.2l-5.1-11.2l0,0c1.5-0.8,3.4-0.6,4.6,0.7l2.8,3.1l6-9.6c1.8-2.9,6.1-3.2,8.2-0.5l0,0 c1.2,1.5,1.5,3.6,0.7,5.3l-2.5,6.1c-0.7,1.8-2,3.5-3.6,4.7l-2.1,1.7v5.7L828.5,119.9L828.5,119.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M835.6,112.8L835.6,112.8c-0.2,0-0.3-0.2-0.3-0.3c0.1-3.7-4.6-5.7-4.7-5.7c-0.2-0.1-0.3-0.3-0.2-0.4 c0.1-0.2,0.3-0.3,0.4-0.2c0.1,0,1.3,0.6,2.6,1.6c1.7,1.4,2.6,3,2.5,4.7C835.9,112.6,835.8,112.8,835.6,112.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M728.8,119.9v-6.2l5.1-11.2l0,0c-1.5-0.8-3.4-0.6-4.6,0.7l-2.8,3.1l-6-9.5c-1.8-2.9-6.1-3.2-8.2-0.5l0,0 c-1.2,1.5-1.5,3.6-0.7,5.3l2.5,6.1c0.7,1.8,2,3.5,3.6,4.7l2.1,1.7v5.7H728.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M721.8,112.8c-0.2,0-0.3-0.1-0.3-0.3c0-1.7,0.8-3.3,2.5-4.7c1.3-1,2.5-1.6,2.6-1.6c0.2-0.1,0.4,0,0.4,0.2 c0.1,0.2,0,0.4-0.2,0.4c-0.1,0-4.8,2-4.7,5.7C722,112.6,721.9,112.8,721.8,112.8L721.8,112.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M803,303.9c-0.2,0-0.5-0.2-0.6-0.4c-0.1-0.3,0-0.6,0.4-0.7l16.4-5.9c0.3-0.1,0.6,0,0.7,0.4 c0.1,0.3,0,0.6-0.4,0.7l-16.4,5.9C803.2,303.9,803.1,303.9,803,303.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M755.3,301c-0.1,0-0.1,0-0.2,0l-16.4-5.9c-0.3-0.1-0.5-0.5-0.4-0.7c0.1-0.3,0.5-0.5,0.7-0.4l16.4,5.9 c0.3,0.1,0.5,0.5,0.4,0.7C755.8,300.9,755.6,301,755.3,301z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M951.6,527.6H11.1c-0.6,0-0.9-0.5-0.9-0.9c0-0.6,0.5-0.9,0.9-0.9h940.5c0.6,0,0.9,0.5,0.9,0.9 C952.5,527.2,952.2,527.6,951.6,527.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractAgreement01);
export default __webpack_public_path__ + "static/media/contract_agreement-01.bc9fbb00131c6bd0b4599f1f931315cd.svg";
export { ForwardRef as ReactComponent };